import { useContext } from 'react'

import { UserContext, type UserContextValue } from './UserContext'

export function useUserContext(): UserContextValue {
  const ctx = useContext(UserContext)
  if (!ctx) {
    throw new Error('useUserContext must be inside UserContextProvider')
  }
  return ctx
}
